import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import {
  getPurchaseCfopData,
  getPurchaseDateSupplierWorkorder,
  getPurchaseDocumentType,
  getPurchaseSupplierSynthetic,
} from './PurchaseReport.service';

const commonMutationOptions = <T>(reportName: string) => {
  return {
    onSuccess(data: T[]) {
      data.length > 0
        ? notification.success({
            message: 'Relatório gerado com sucesso!',
            description: `Relatório de ${reportName} gerado com sucesso.`,
          })
        : notification.info({
            message: 'Nenhum dado encontrado para este relatório',
          });
    },
    onError(err: unknown) {
      notificationError(err);
    },
  };
};

export function usePurchaseCfopData() {
  const mutation = useMutation(
    getPurchaseCfopData,
    commonMutationOptions('Compra por CFOP'),
  );
  return mutation;
}

export function usePurchaseDateSupplierWorkorder() {
  const mutation = useMutation(
    getPurchaseDateSupplierWorkorder,
    commonMutationOptions('Compra'),
  );
  return mutation;
}

export function usePurchaseDocumentType() {
  const mutation = useMutation(
    getPurchaseDocumentType,
    commonMutationOptions('Compra por tipo de documento'),
  );
  return mutation;
}

export function usePurchaseSupplierSynthetic() {
  const mutation = useMutation(
    getPurchaseSupplierSynthetic,
    commonMutationOptions('Compra por fornecedor sintético'),
  );
  return mutation;
}
